export default __webpack_public_path__ + "static/pactt-e5af4ab6e11d4ea516cea6b2ceccafe0.png";